export default "__VITE_ASSET__bdc6fedf__"